module.exports = "/packs/step2-9a7f1cf8671f7c3d4e400aa9c0c6cf8c.png";